<template>
  <v-flex class="agent-upload-logo">
    <v-card id="agentUploadLogo">
      <v-card-title class="card-title">
        Company Logo
      </v-card-title>
      <v-divider />
      <v-card-title class="card-title">
        Logo
        <span @click="showUploadLogoModal = true">UPDATE LOGO</span>
      </v-card-title>
      <v-card-text>
        <div v-if="!getAgentLogo">
          <div class="upload-logo-container">
            <v-icon :color="colors.hwayzDarkGray" size="56">
              fas fa-image
            </v-icon>
          </div>
        </div>
        <v-flex v-else class="logo-container">
          <v-hover>
            <div slot-scope="{ hover }" class="logo-container-placeholder">
              <img
                :src="getAgentLogo.link"
                @click="openFullSizeImage(getAgentLogo.link)"
              >
              <v-fade-transition>
                <v-layout v-if="hover" class="logo-hover white--text">
                  <v-flex>
                    <v-icon
                      :color="colors.hwayzWhite"
                      class="hover-icon"
                      title="delete"
                      @click="deleteDocument"
                    >
                      fas fa-times
                    </v-icon>
                  </v-flex>
                </v-layout>
              </v-fade-transition>
            </div>
          </v-hover>
        </v-flex>
      </v-card-text>
    </v-card>
    <default-modal
      :show-modal="showModal"
      :width="'70%'"
      @close-modal="showModal = false"
    >
      <img :src="fullImage" class="fullImage">
    </default-modal>
    <default-modal
      :show-modal="showUploadLogoModal"
      :width="'450px'"
      :modal-title="'Upload Logo'"
      @close-modal="closeUpdateLogoModal"
    >
      <file-pond
        ref="pond"
        name="test"
        label-idle="Drop files here..."
        :allow-multiple="true"
        image-validate-size-min-width="160"
        image-validate-size-min-height="80"
        image-validate-size-max-width="1024"
        image-validate-size-max-height="920"
        accepted-file-types="image/jpeg, image/png, image/svg+xml"
      />
      <v-btn
        class="submit-logo-button"
        :color="colors.hwayzBrandBlue"
        @click="updateLogo()"
      >
        UPLOAD LOGO
      </v-btn>
    </default-modal>
  </v-flex>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import colors from '../../scss/_colors.scss'
import DefaultModal from '../../components/modals/DefaultModal'
import { uploadLogo, removeLogo } from '../../services/profile'

export default {
  components: { DefaultModal },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      fullImage: null,
      showModal: false,
      showUploadLogoModal: false
    }
  },
  computed: {
    ...mapState('agent', ['agentData']),
    ...mapGetters('agent', ['getAgentLogo', 'getClients'])
  },
  watch: {
    newLogo() {
      this.updateLogo()
    }
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    async updateLogo() {
      let newLogo = this.$refs.pond.getFiles()
      newLogo = newLogo[0] ? newLogo[0].file : undefined

      if (newLogo) {
        await this.addDataToLogoUploader(newLogo)
        this.$refs.pond.removeFile()
      }
    },
    async addDataToLogoUploader(logo) {
      const imageFormData = new FormData()
      imageFormData.append('upload', logo)
      this.closeUpdateLogoModal()
      const updatedLogo = await uploadLogo(this.profile, 'logo', imageFormData)
      updatedLogo.clients = this.getClient
      this.setAgentData(updatedLogo)
    },
    async deleteDocument() {
      if (this.profile) {
        const updatedLogo = await removeLogo(this.profile, this.getAgentLogo)
        updatedLogo.clients = this.getClients
        this.setAgentData(updatedLogo)
      }
    },
    openFullSizeImage(logo) {
      this.fullImage = logo
      this.showModal = true
    },
    closeUpdateLogoModal() {
      this.showUploadLogoModal = false
      this.newLogoModal = null
    }
  }
}
</script>

<style lang="sass">
.agent-upload-logo
  max-height: 300px
  display: flex
#agentUploadLogo
  width: 100%
  height: 100%
.upload-logo-container
  background: $color-grey
.upload-logo-container, .logo-container
  width: 95%
  height: 120px
  margin: 1rem auto 1.5rem
  display: flex
  align-content: center
  justify-content: center
.logo-container
  img
    width: auto
    height: 100%
  div
    margin: 0.2rem
  &-placeholder
    display: flex
    align-items: center
    justify-content: center
    margin: 0 auto
    position: relative
    height: 100% !important
    width: 100% !important
  .logo-hover
    pointer-events: none
    position: absolute
    bottom: 0
    top: 0
    left: 0
    right: 0
    margin: 0 !important
    background-color: $hwayzMediumGray
    opacity: 0.9
    color: $hwayzWhite
    .hover-icon
      pointer-events: all
      font-size: $hwayzFont1rem6
      position: absolute
      top: 0.5rem !important
      right: 0.5rem !important
      cursor: pointer
</style>
